import { forwardRef } from "react";
import { FormFieldInfo } from "@/components/form/field/info";
import type { AppFormFieldPartProps } from "@/form/components/types";

export const AppFormFieldInfo = forwardRef<
  HTMLIonNoteElement,
  React.ComponentProps<typeof FormFieldInfo> & AppFormFieldPartProps
>(function AppFormFieldLabel(props, ref) {
  return <FormFieldInfo ref={ref} {...props} />;
});
